module.exports = __webpack_public_path__ + "img/save_outlined_64.77bb75ff.svg";